<div class="detail-info" [ngClass]="cssClass">
  <legend class="h3 mb-16px"> {{title}} </legend>
  <ng-content></ng-content>
</div>
